import axios from "axios";
import md5 from "js-md5";
let baseURL = "";
let token = localStorage.getItem("token");
if (process.env.NODE_ENV == "production") {
  baseURL = "http://api.jfc.jfbst.com/api/v2";
} else {
  // baseURL = "http://localhost:1024";
  baseURL = 'http://api.jfc.jfbst.com/api/v2';
}

const service = axios.create({
  baseURL: baseURL,
  timeout: 10000,
});

service.interceptors.request.use(
  (config) => {
    let time = new Date().getTime();
    // config.params["time"] = time;
    config.headers["sign"] = time + md5(time + "test");
    config.headers["token"] = localStorage.getItem("token");
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    //return Promise.reject(error);
  }
);
export function getData(url, params) {
  return new Promise((resolve, reject) => {
    service
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        resolve(err);
      });
  });
}

export function postData(url, param) {
  return new Promise((resolve, reject) => {
    service
      .post(url, param)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export { baseURL as apiUrl };
